module.exports = {

    string(length = 16, seperator = '') {
        const captures = [];
        while(captures.length * 4 < length) {
            captures.push(genS4());
        }
        return captures.join(seperator);
    },

};

function genS4() {
    return Math.floor(Math.random() * 0xFFFFF).toString(36);
}